module.exports = __webpack_public_path__ + "static/HF_CQSSC-3a2a002a3b74f044dc1be386bb47e61e.png";